import React, { useEffect, useState } from 'react'
import { Row, Table, Col, Flex } from 'antd'
import ZCard from '../../../../Card/Index'
import CustomTypography from '../../../../common/CustomTypography'
import { circularTxn as circularJson } from '../../../../../utils/JsonData/circularTxn'
import styles from '../../../UPITxnAnalysis/upiTxnAnalysis.module.scss'
import { StarFilled } from '@ant-design/icons';
import { useSelector } from 'react-redux'
import { circularTxn } from '../../../../../api/commonApis'
import { CURRENCY } from '../../../../../utils/ConstantData'
import CustomAmountText from '../../../../common/CustomAmountText'
import { Title } from 'chart.js'

const SectionHeader = ({ title }) => {
    return (
        <Flex className="pb-8">
            <CustomTypography style={{ fontWeight: 700, fontSize: "14px", lineHeight: "22px", color: "#000000E0", fontFamily: "Satoshi" }}>{title}</CustomTypography>
        </Flex>
    );
}

const summaryColumns = [
    {
        key: "txnType",
        dataIndex: "txnType",
        title: "Transaction Date",
        className: `${styles.colHighlighted}`
    },
    {
        key: "particulars",
        dataIndex: "particulars",
        title: "Particulars",
        // className: styles.tdTextStyle
    },
    {
        key: "endDate",
        dataIndex: "endDate",
        title: "Debit",
        // className: styles.tdTextStyle
    },
    {
        key: "endDate",
        dataIndex: "endDate",
        title: "Credit",
        // className: styles.tdTextStyle
    },
];

const CircularTxn = () => {
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    const [circulartxn, setCirculartxn] = useState({});
    const [utilData, setUtilData] = useState([]);
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);


    useEffect(() => {

        const fetchData = async () => {
          try {
            let aggregate = selectedAccountId !== 'all'? false : true;
            let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
            const response = await circularTxn(account_id, aggregate);

            console.log("RESPONSE", response);
    
            if(Object.keys(response).length > 0){
                let data = response?.circular?.map((item) => {
                    let circularTransferRes = item?.circular;
                    let fisrtIdPairRes = item?.idPair[0];
                    let secondIdPairRes = item?.idPair[1];
                    let yesbin02202Data = item?.circular.filter((item) => item.bankAccountId === fisrtIdPairRes && item.type === 'CR' );
                    let yesbin03563Data = item?.circular.filter((item) => item.bankAccountId === secondIdPairRes && item.type === 'DB');
                    let title1 = item?.accountPair[0];
                    let title2 = item?.accountPair[1];

                    let obj = {
                        circularTransfer: circularTransferRes,
                        fisrtIdPair: fisrtIdPairRes,
                        secondIdPair: secondIdPairRes,
                        titleOne: title1,
                        titleTwo: title2,
                        data1: yesbin02202Data,
                        data2: yesbin03563Data
                    }

                    // console.log("CIRCULAR MAP", obj);

                    return obj;
                    
                })                
                setUtilData(data);
            } else{
                setUtilData([])
            }
    
          } catch (error) {
    
            console.log("ERROR", error);
          }
        }
    
        if (selectedAccountId) fetchData();
      }, [selectedAccountId]);

    //   console.log("CIRCULAT TRANSACTION>>>>", circulartxn);
    //   let circular = circulartxn?.circular[0];

    // console.log("TXN", circularTransfer, fisrtIdPair, secondIdPair);
    
    
    // const yesbin02202Data = circularTransfer.filter((item) => item.bankAccountId === fisrtIdPair);
    // const yesbin03563Data = circularTransfer.filter((item) => item.bankAccountId === secondIdPair);

    // console.log("yesbin03563Data", data1, data2);
    

    // const calculateTotal = (data) => {
    //     const totalDebit = data.reduce((sum, item) => (item.type === 'DB' ? sum + item.amount : sum),0);
    //     const totalCredit = data.reduce((sum, item) => (item.type === 'CR' ? sum + item.amount : sum),0);
    
    //     return { totalDebit, totalCredit };
    // };

    // const yesbin02202Totals = calculateTotal(data1);
    // const yesbin03563Totals = calculateTotal(data2);
    

    const columns = [
      {
        title: 'Txn Date',
        dataIndex: 'date',
        key: 'date',
        width: 180
      },
      {
        title: 'Particulars',
        dataIndex: 'particulars',
        key: 'particulars',
        width: 190
      },
      {
        title: `Debit (${CURRENCY})`,
        dataIndex: 'debit',
        key: 'debit',
        align: 'right',
        className: 'no-wrap-column',
        render: (text, record) => (record.type === 'DB' ? <CustomAmountText value={record.amount} /> : ''),
      },
      {
        title: `Credit (${CURRENCY})`,
        dataIndex: 'credit',
        key: 'credit',
        align: 'right',
        className: 'no-wrap-column',
        render: (text, record) => (record.type === 'CR' ? <CustomAmountText value={record.amount} /> : ''),
      },
    ];
      
    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
            {utilData?.map((item) => {
               return (<>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <Flex className='pl-16 ' justify='space-between'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
                                <ZCard.Title>{`${item?.titleOne === undefined ? 'No data' : item?.titleOne}`}</ZCard.Title>
                            </div>
                        </Flex>
                        <Table
                            columns={columns}
                            dataSource={item?.data1}
                            // rowKey={(record) => `${record.bankAccountId}-${record.date}-${record.amount}`}
                            // pagination={{ pageSize: 5 }}
                            // summary={() => (
                            //     <Table.Summary.Row>
                            //     <Table.Summary.Cell />
                            //     <Table.Summary.Cell>Total</Table.Summary.Cell>
                            //     <Table.Summary.Cell>{<CustomAmountText value={yesbin02202Totals.totalDebit.toFixed(2)} />}</Table.Summary.Cell>
                            //     <Table.Summary.Cell>{<CustomAmountText value={yesbin02202Totals.totalCredit.toFixed(2)} />}</Table.Summary.Cell>
                            //     </Table.Summary.Row>
                            // )}
                        />
                    </ZCard>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <ZCard>
                        <Flex className='pl-16 ' justify='space-between'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
                                <ZCard.Title>{`${item?.titleTwo === undefined ? 'No data' : item?.titleTwo}`}</ZCard.Title>
                            </div>
                        </Flex>
                        <Table
                            columns={columns}
                            dataSource={item?.data2}
                            // rowKey={(record) => `${record.bankAccountId}-${record.date}-${record.amount}`}
                            // pagination={{ pageSize: 5 }}
                            // summary={() => (
                            //     <Table.Summary.Row>
                            //     <Table.Summary.Cell />
                            //     <Table.Summary.Cell>Total</Table.Summary.Cell>
                            //     <Table.Summary.Cell>{ <CustomAmountText value={yesbin03563Totals.totalDebit.toFixed(2)} />}</Table.Summary.Cell>
                            //     <Table.Summary.Cell>{<CustomAmountText value={yesbin03563Totals.totalCredit.toFixed(2)} />}</Table.Summary.Cell>
                            //     </Table.Summary.Row>
                            // )}
                        />
                    </ZCard>
                </Col>
                    </>
               ) 
            })}
        </Row>
    )
}

export default CircularTxn